namespace Solovis.Reports.DataSetHelpers {
    
    /**
     * ResourceMarketValueIndex will index values returned from the /Solovis/MarketValues/ResourceMarketValueHistory data source. 
     */
    export class ResourceMarketValueIndex {

        public _resourceIdToDayIdValueMap;

        constructor() {
            this._resourceIdToDayIdValueMap = {};
        }

        /**
         * values returned from the /Solovis/MarketValues/ResourceMarketValueHistory data source.
         * @param marketValueDataSet
         */
        public mergeValues(marketValueDataSet) {
            // marketValueDataSet should be an array of values that has (dayId, resourceId, totalValue, unitPrice, units, valueTypeId)

            var self = this;

            if (marketValueDataSet) {
                $(marketValueDataSet).each(function (i, mvData: any) {
                    var dayIdToValueMap;
                    if (self._resourceIdToDayIdValueMap[mvData.resourceId]) {
                        dayIdToValueMap = self._resourceIdToDayIdValueMap[mvData.resourceId];
                    }
                    else {
                        dayIdToValueMap = {};
                        self._resourceIdToDayIdValueMap[mvData.resourceId] = dayIdToValueMap;
                    }

                    dayIdToValueMap[mvData.dayId] = mvData;
                });
            }
        }

        /**
         * getValue will return the mvData holder; or null, if none is found.
         * @param resourceId
         * @param dayId
         */
        public getValue(resourceId, dayId) {           
            if (this._resourceIdToDayIdValueMap[resourceId]) {
                var dayIdToValueMap = this._resourceIdToDayIdValueMap[resourceId];
                if (dayIdToValueMap[dayId]) {
                    var mvData = dayIdToValueMap[dayId];
                    return mvData;
                }
            }

            return null;
        }

        /**
         * getLatestValueAsOfDayId will return the most recent mvData holder as of given date; or null, if none is found.
         * @param resourceId
         * @param dayId
         */
        public getLatestValueAsOfDayId(resourceId, dayId) {
            var mostRecent = null;

            if (this._resourceIdToDayIdValueMap[resourceId]) {
                var dayIdToValueMap = this._resourceIdToDayIdValueMap[resourceId];
                for (var key in dayIdToValueMap) {
                    var mvData = dayIdToValueMap[key];
                    if (mvData.dayId <= dayId) {
                        if (mostRecent == null) {
                            mostRecent = mvData;
                        }
                        else {
                            if (mvData.dayId > mostRecent.dayId) {
                                mostRecent = mvData;
                            }
                        }
                    }
                }
            }

            return mostRecent;
        }
    }

}
